export var LicensingModalType;
(function (LicensingModalType) {
    LicensingModalType["LIST"] = "list";
    LicensingModalType["ACTIVATION"] = "activation";
    LicensingModalType["DEACTIVATION"] = "deactivation";
})(LicensingModalType || (LicensingModalType = {}));
export var SeatsToastVisibleStatusType;
(function (SeatsToastVisibleStatusType) {
    SeatsToastVisibleStatusType["RELEASED"] = "released";
    SeatsToastVisibleStatusType["OCCUPIED"] = "occupied";
})(SeatsToastVisibleStatusType || (SeatsToastVisibleStatusType = {}));
